export default __webpack_public_path__ + "static/media/rocket-title.c8e7175d.svg";